var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTurtle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 51 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.025 1.00014C40.975 0.900141 37.95 3.25014 37 7.00014C35.75 12.0001 35.75 12.0001 33.25 14.5001C28.25 19.5001 20.75 22.0001 5.75 24.5001C3.25 24.9001 2 25.7501 0.75 27.0001C5.75 27.0001 10.75 27.0001 7 30.7501L3.25 34.5001H10.75L15.75 29.5001C20.75 32.0001 24.075 32.0001 29.075 29.5001L30.75 34.5001H38.25L35.75 27.0001C35.75 27.0001 38.25 17.0001 40.75 14.5001C43.25 12.0001 43.25 14.5001 45.75 14.5001C48.25 14.5001 50.75 12.0001 50.75 8.25014C50.75 7.00014 50.75 4.50014 47 2.00014C46.125 1.40014 45.1 1.05014 44.025 1.00014ZM18.25 2.00014C14.2718 2.00014 10.4564 3.58049 7.6434 6.39354C4.83035 9.20658 3.25 13.0219 3.25 17.0001C3.25 18.5001 3.575 19.7001 3.825 21.0001C18.625 18.5501 26.475 15.9751 30.575 11.8501L31.825 10.6001C29.35 5.35014 24.05 2.00014 18.25 2.00014Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurtle);
export default __webpack_public_path__ + "static/media/turtle.650edc4be5c39a10dccf0b6ea91dad4e.svg";
export { ForwardRef as ReactComponent };